// Calcula a posição em pixels do cursor dentro de um <textarea>/<input>
// usando a técnica do "mirror div". Adaptado de component/textarea-caret-position.

const properties = [
    'direction', 'boxSizing', 'width', 'height', 'overflowX', 'overflowY',
    'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
    'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft',
    'fontStyle', 'fontVariant', 'fontWeight', 'fontStretch', 'fontSize',
    'fontSizeAdjust', 'lineHeight', 'fontFamily', 'textAlign', 'textTransform',
    'textIndent', 'textDecoration', 'letterSpacing', 'wordSpacing', 'tabSize'
];

export const getCaretCoordinates = (element, position) => {
    const div = document.createElement('div');
    document.body.appendChild(div);

    const style = div.style;
    const computed = window.getComputedStyle(element);

    style.whiteSpace = 'pre-wrap';
    style.wordWrap = 'break-word';
    style.position = 'absolute';
    style.visibility = 'hidden';
    properties.forEach(prop => { style[prop] = computed[prop]; });
    style.overflow = 'hidden';

    div.textContent = element.value.substring(0, position);

    const span = document.createElement('span');
    span.textContent = element.value.substring(position) || '.';
    div.appendChild(span);

    const coordinates = {
        top: span.offsetTop + parseInt(computed.borderTopWidth, 10),
        left: span.offsetLeft + parseInt(computed.borderLeftWidth, 10),
        height: parseInt(computed.lineHeight, 10) || parseInt(computed.fontSize, 10)
    };

    document.body.removeChild(div);
    return coordinates;
};
